<template>
  <div class="treeview"
       v-if="items"
       :style="{height: height ? 'calc('+height+ ' - 102px' : '1000px'}"
  >
    <v-treeview
      v-show="isTreeview"
      dense
      @update:active="$emit('select-directory', $event)"
      :open.sync="openItems"
      :active.sync="activeItems"
      hoverable
      activatable
      color="#009bdf"
      :items="items"
      :key="treeviewKey"
      :item-key="'physicalPath'"
      :load-children="loadContent"
      ref="treeview"
    >
      <template v-slot:prepend="{ item }">
        <v-icon v-if="item.iconDisabled === true">
          mdi-alert
        </v-icon>
        <v-progress-circular
          v-else-if="item.contentLoading"
          indeterminate
          color="primary"
          size="24"
        ></v-progress-circular>
        <v-icon v-else-if="item.locationType === 'HardDisk'">
          mdi-harddisk
        </v-icon>
        <v-icon v-else-if="item.locationType === 'Network'">
          mdi-server-network
        </v-icon>
        <v-icon v-else-if="item.locationType === 'Cloud'">
          mdi-cloud
        </v-icon>
        <v-icon v-else>
          mdi-folder
        </v-icon>
      </template>
    </v-treeview>
  </div>
</template>

<script>

import {SET_ACTIVE_ITEMS, SET_OPEN_ITEMS} from "@/utils/mutation-types";

export default {
  name:  "Treeview",
  props: {
    height:      String,
    isTreeview:  Boolean,
    loadContent: Function,
    treeviewKey: Number,
    items:       Array
  },
  computed: {
    activeItems: {
      get: function () {
        return this.$store.state.activeItems;
      },
      set: function (newValue) {
        this.$store.commit(SET_ACTIVE_ITEMS, newValue);
      }
    },
    openItems: {
      get: function () {
        return this.$store.state.openItems;
      },
      set: function (newValue) {
        this.$store.commit(SET_OPEN_ITEMS, newValue);
      }
    },
  }
}
</script>

<style scoped>
.treeview {
  width: 300px;
  font-size: 14px;
  overflow-y: auto;
  padding-bottom: 20px;
}
@media (max-width: 800px) {
  .treeview {
    height: calc(100% - 102px);
  }
}

@media (max-width: 500px) {
  .treeview {
    width: 100%;
  }
}
</style>
